import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SuperAdminAuthProvider, useSuperAdminAuth } from './contexts/SuperAdminAuthContext';
import SuperAdminLogin from './pages/SuperAdminLogin';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import TenantUsersPage from './pages/TenantUsersPage';

const SuperAdminRouter: React.FC = () => {
  const { isAuthenticated, loading } = useSuperAdminAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f8fafc'
      }}>
        <div>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e5e7eb',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{ color: '#64748b', textAlign: 'center' }}>
            Caricamento Super Admin...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <SuperAdminLogin />;
  }

  return (
    <Routes>
      <Route path="/superadmin" element={<SuperAdminDashboard />} />
      <Route path="/superadmin/tenants/:tenantId/users" element={<TenantUsersPage />} />
      <Route path="/superadmin/*" element={<Navigate to="/superadmin" replace />} />
    </Routes>
  );
};

const SuperAdminApp: React.FC = () => {
  return (
    <SuperAdminAuthProvider>
      <Router>
        <div className="superadmin-app">
          <SuperAdminRouter />
        </div>
      </Router>
    </SuperAdminAuthProvider>
  );
};

export default SuperAdminApp;
